module.exports = __webpack_public_path__ + "static/img/balloons@2x.da95823.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/balloons@2x.png
// module id = xF8K
// module chunks = 1